import { compose, withHandlers } from 'recompose';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import List from '../components/List';
import { getAll } from '../selectors';


const ListContainer = compose(
  withRouter,
  connect(
    (state, ownProps) => ({
      items: getAll(state),
      baseUrl: ownProps.location.pathname,
    }),
  ),
  withHandlers({
    onClick: props => id => () => {
      if (id) props.router.push(`${props.baseUrl}/${id}/edit`);
    },
  }),
);

export default ListContainer(List);
